import "./css/answersheet.css"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import Footer from "./../footer/footer"

const Answersheet = () => {
    const data = JSON.parse(sessionStorage.getItem("data")) || 0
    const navigate = useNavigate()
    const answersheetData = []
    
    useEffect(() => {
        if (Object.keys(data).length === 0) {
            navigate("/profile/result")
        }
    }, [data, navigate])

    // Logic kept intact
    const splitlanguage = data.paperData?.language?.split("\n") || []

    if (splitlanguage.length === 1) {
        for (let i = 0; i < Object.keys(data.languageOne).length; i++) {
            answersheetData.push({
                questionid: data.languageOne[i].questionId,
                testcode: data.languageOne[i].testcode,
                questionone: data.languageOne[i].questionOne,
                optiononelanguageone: data.languageOne[i].questionOneOptionOne,
                optiontwolanguageone: data.languageOne[i].questionOneOptionTwo,
                optionthreelanguageone: data.languageOne[i].questionOneOptionThree,
                optionfourlanguageone: data.languageOne[i].questionOneOptionFour,
                answer: data.answer[i].answer,
                QNo: data.answer[i].QNo,
            })
        }
    }
    
    if (splitlanguage.length === 2) {
        for (let i = 0; i < Object.keys(data.languageOne).length; i++) {
            answersheetData.push({
                questionid: data.languageOne[i].questionId,
                testcode: data.languageOne[i].testcode,
                questionone: data.languageOne[i].questionOne,
                optiononelanguageone: data.languageOne[i].questionOneOptionOne,
                optiontwolanguageone: data.languageOne[i].questionOneOptionTwo,
                optionthreelanguageone: data.languageOne[i].questionOneOptionThree,
                optionfourlanguageone: data.languageOne[i].questionOneOptionFour,
                questiontwo: data?.languagetwo[i]?.questionTwo,
                optiononelanguagetwo: data?.languagetwo[i]?.questionTwoOptionOne,
                optiontwolanguagetwo: data?.languagetwo[i]?.questionTwoOptionTwo,
                optionthreelanguagetwo: data?.languagetwo[i]?.questionTwoOptionThree,
                optionfourlanguagetwo: data?.languagetwo[i]?.questionTwoOptionFour,
                answer: data.answer[i].answer,
                QNo: data.answer[i].QNo,
            })
        }
    }

    answersheetData.sort((a, b) => parseInt(a.QNo) - parseInt(b.QNo));

    for (let i = 0; i < answersheetData.length; i++) {
        if (data.userAnswer && data.userAnswer[i]) {
            answersheetData[i].userAnswer = data.userAnswer[i].answer;
            answersheetData[i].answerStatus =
                answersheetData[i].questionid === data.userAnswer[i].questionid &&
                    answersheetData[i].answer === data.userAnswer[i].answer
                    ? "Correct"
                    : "Incorrect";
        }
    }

    return (
        <div className="sheetPageWrapper">
            
            {/* Main Content Area that pushes footer down */}
            <div className="sheetMainContent">
                <div className="sheetHeaderContainer">
                    <div className="sheetMainTitle">
                        <h2>Answer Sheet</h2>
                        <p>{data?.paperData?.examname} / {data?.paperData?.papername}</p>
                    </div>
                    
                    <div className="sheetInfoGrid">
                        <div className="sheetInfoBox">
                            <span className="sheetInfoLabel">Type</span>
                            <span className="sheetInfoValue">{data?.paperData?.type}</span>
                        </div>

                        <div className="sheetInfoBox">
                            <span className="sheetInfoLabel">Test Code</span>
                            {data?.paperData?.year ? (
                                <span className="sheetInfoValue">{data?.paperData?.year}</span>
                            ) : data?.paperData?.seriescode ? (
                                <span className="sheetInfoValue">
                                    {data?.paperData?.seriescode} / {data?.paperData?.seriesno}
                                </span>
                            ) : (
                                <span className="sheetInfoValue">N/A</span>
                            )}
                        </div>

                        <div className="sheetInfoBox">
                            <span className="sheetInfoLabel">Date</span>
                            <span className="sheetInfoValue">
                                {data?.result?.startDate ? data.result.startDate.replace(/ /g, "/") : "N/A"}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="sheetQuestionsWrapper">
                    <div className="sheetQuestionsList">
                        {answersheetData.map((item, index) => {
                            return (
                                <div className="questionCard" key={index + 1}>
                                    <div className="questionIndexBadge">
                                        Q.{index + 1}
                                    </div>
                                    
                                    <div className="questionMainContent">
                                        <div className="questionText">
                                            <div dangerouslySetInnerHTML={{ __html: item.questionone }} />
                                            {item.questiontwo && (
                                                <div dangerouslySetInnerHTML={{ __html: item.questiontwo }} className="questionTextSecondary" />
                                            )}
                                        </div>

                                        {/* Option A */}
                                        <div className={`optionRow ${item.userAnswer === "a" && item.answer === "a" ? "optionCorrect" : item.userAnswer === "a" ? "optionIncorrect" : ""}`}>
                                            <div className="optionLabel">(A)</div>
                                            <div className="optionContent">
                                                <div dangerouslySetInnerHTML={{ __html: item.optiononelanguageone }} />
                                                {item.optiononelanguagetwo && <div dangerouslySetInnerHTML={{ __html: item.optiononelanguagetwo }} />}
                                            </div>
                                        </div>

                                        {/* Option B */}
                                        <div className={`optionRow ${item.userAnswer === "b" && item.answer === "b" ? "optionCorrect" : item.userAnswer === "b" ? "optionIncorrect" : ""}`}>
                                            <div className="optionLabel">(B)</div>
                                            <div className="optionContent">
                                                <div dangerouslySetInnerHTML={{ __html: item.optionfourlanguageone }} />
                                                {item.optionfourlanguagetwo && <div dangerouslySetInnerHTML={{ __html: item.optionfourlanguagetwo }} />}
                                            </div>
                                        </div>

                                        {/* Option C */}
                                        <div className={`optionRow ${item.userAnswer === "c" && item.answer === "c" ? "optionCorrect" : item.userAnswer === "c" ? "optionIncorrect" : ""}`}>
                                            <div className="optionLabel">(C)</div>
                                            <div className="optionContent">
                                                <div dangerouslySetInnerHTML={{ __html: item.optiontwolanguageone }} />
                                                {item.optiontwolanguagetwo && <div dangerouslySetInnerHTML={{ __html: item.optiontwolanguagetwo }} />}
                                            </div>
                                        </div>

                                        {/* Option D */}
                                        <div className={`optionRow ${item.userAnswer === "d" && item.answer === "d" ? "optionCorrect" : item.userAnswer === "d" ? "optionIncorrect" : ""}`}>
                                            <div className="optionLabel">(D)</div>
                                            <div className="optionContent">
                                                <div dangerouslySetInnerHTML={{ __html: item.optiontwolanguageone }} />
                                                {item.optiontwolanguagetwo && <div dangerouslySetInnerHTML={{ __html: item.optiontwolanguagetwo }} />}
                                            </div>
                                        </div>

                                        <div className="answerSummaryFooter">
                                            <div className="answerBlock correctAnswerBlock">
                                                <span className="answerSummaryLabel"><i className="fa-solid fa-check"></i> Correct Answer :</span>
                                                <span className="answerSummaryValue">{item.answer}</span>
                                            </div>

                                            <div className="answerBlock givenAnswerBlock">
                                                {item.userAnswer === undefined ? (
                                                    <span className="notAttemptedText"><i className="fa-regular fa-circle"></i> Not Attempted</span>
                                                ) : (
                                                    <>
                                                        <span className="answerSummaryLabel">
                                                            {item.answerStatus === "Correct" ? <i className="fa-solid fa-check-double"></i> : <i className="fa-solid fa-xmark"></i>} Given Answer :
                                                        </span>
                                                        <span className={`answerSummaryValue ${item.answerStatus === "Correct" ? "textSuccess" : "textDanger"}`}>
                                                            {item.userAnswer}
                                                        </span>
                                                    </>
                                                )}
                                            </div>

                                            <div className="reportActionContainer">
                                                <button className="reportBtn"><i className="fa-regular fa-flag"></i> Report Question</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

            {/* Footer Wrapper - takes full width and stays at bottom */}
            <div className="sheetFooterWrapper">
                <Footer/>
            </div>
            
        </div>
    )
}

export default Answersheet